import React, { useState } from 'react'
import { CssBaseline } from '@material-ui/core'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

import { AppToolbar, AppDrawer } from './common'
import { ChangeLog, Home, MotionCharactor, Neta, NetaImage } from '../pages'

const useDrawer = () => {
  const [open, setOpen] = useState<boolean>(false)
  const onClose = () => setOpen(false)
  return { open, onClose, setOpen }
}

const App: React.VFC = () => {
  const drawer = useDrawer()

  const { setOpen, ...drawerProps } = drawer
  const openDrawer = () => setOpen(true)

  return (
    <div className="App">
      <Router>
        <CssBaseline />

        <AppToolbar openDrawer={openDrawer} />
        <AppDrawer {...drawerProps} />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/motion_charactor" exact component={MotionCharactor} />
          <Route path="/neta" exact component={Neta} />
          <Route path="/netaimage" exact component={NetaImage} />
          <Route path="/change_log" exact component={ChangeLog} />
        </Switch>
      </Router>
    </div>
  )
}

export default App
